import React from "react";
import SeoMeta from "../components/meta";
import CarSuggestBody from "../components/car-suggest";

export default function CarSuggest() {
  return (
    <>
      <SeoMeta title="Car Suggest | FameWheels" desc="Thinking of buying a car? At FameWheeels.com, buy new and used cars, search by filter and preferences, compare cars, read latest news and updates!" />

      <CarSuggestBody />
    </>
  );
}
